<template >
    <div class="container-fluid">
      
     <div class="modal" id="modalCleanTotal" role="dialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        
        <div class="modal-content">
          <div class="modal-header bg-modal border border-success">
            <h4 style="color:white" class="modal-title" id="staticBackdropLabel">
              <i style ="color:white" class="fas fa-edit mr-3" aria-hidden="true"></i>
              MODIFICA TOTALE VENDITA</h4>          
          </div>
          <form v-on:submit.prevent="submit()">
          <div class="modal-body">        
            <div class="">
               
                <label for="inputTotal" class="form-label"><strong>TOTALE VENDITA</strong></label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <div class="input-group-text ">€</div>
                    </div>
                    <input  v-focus ref="inputCleanTotal"  @input="setTotal()" step="0.01"  required type="number" id="cleanTotal" class="form-control" v-model="netTotal" >
                    
                    </div>
                    <small>
                      Il valore dell'abbuono verrà calcolato automaticamente.
                    </small>
                
               
                
                <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
            </div>

            <total-discount @setDiscount="setDiscount" :key="refresh" v-bind:item="totals"></total-discount>  

          </div>
          
          
          

        <!--  <small class="ml-3 mr-4" style="font-size: 24px; color:red"> <strong><span style=" font-size: 20px;  color:black">SCONTO </span> <span class="ml-3">{{ discount }} % </span></strong></small>-->
          <div class="modal-footer">
           
           <!-- <button type="button" class="btn btn-secondary float-left" data-dismiss="modal">
                <i style ="color:yellow" class="fas fa-reply mr-3 " aria-hidden="true"></i>
                ANNULLA</button>-->
            
            <button :disabled="setButton" type="submit" class="btn btn-primary" >
                
                APPLICA
                <i style ="color:yellow" class="fas fa-check-circle ml-3" aria-hidden="true"></i>
            </button>
          </div>
        </form>
        </div>
        
      </div>
    </div>
    
    </div>
    </template>
    <script>
    
    import alertBox                   from '@/components/common/AlertBox.vue';
    import totalDiscount              from '@/components/frontOffice/checkOut/totalDiscount.vue';
    import { mapGetters }             from 'vuex';
    
        
    export default {
      props:['props'] , 
      components: { alertBox, totalDiscount },
      
     data () {
        return {
        
        total     : 0,
        netTotal  : 0,
        discount  : 0,
        totals    : {},
        refresh   : 0,
      


        
        
        msg : {
            title : '',
            body  : '',
            type  : 0
          }
    
    
        }
      },
      directives: 
        {
          focus: {
          
            inserted: function (el) {
              
              //el.focus()
              el.select()
              }
               
           
          }
        },
      computed: {
        ...mapGetters(['company','storeId']) ,
        setButton : function()
        {
          
          const total = Math.abs(Number(this.total))
          const netTotal = Math.abs(Number(this.netTotal))
          return netTotal > total
          
        
    }

      },
    mounted()
    {
        $('#modalCleanTotal').on('shown.bs.modal', function (event) {        
        $('#cleanTotal').trigger('focus');
        
    })     
    },  
    created()
    {
      //console.log('TOTALE',this.props)  
      
      this.total    = Number(this.props.total.toFixed(2))
      this.netTotal = this.total

      this.$nextTick()
      .then(() =>{
          
          // DOM updated
         this.totals.netTotal = this.netTotal
         this.totals.total    = this.total
         this.refresh++

        }

      )

      //this.$refs.inputCleanTotal.focus()
    },
    methods : {
   
    setTotal()
    {

        
   

        this.totals.netTotal = this.netTotal
        this.totals.total    = this.total
        this.refresh++
        
        
        
    },
    setDiscount(value)
    {
      this.discount = value
    
    },
    async submit()
    {
        
        this.$emit('update',this.netTotal,this.discount)
        
        
    }
}
}
    </script>
    <style scoped>
    input{
        font-size: 24px;
    }
        .modal-content {
        -webkit-border-radius: 0px !important;
        -moz-border-radius: 25px !important;
        border-radius: 15px !important;
        -webkit-border: 0px !important;
        -moz-border: 15px !important;
        border: 0px !important;

    
      }
      .bg-modal{
       
        background-color: rgb(103, 33, 233);
      }
    </style>
    